import React, { useEffect, useState } from "react";
import './VistaProgramados.scss'
import InputLista from "../../../components/atoms/InputLista/InputLista";
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import Button from "../../../components/atoms/Button/Button";
import TablaMonitoreoVistaProgramados from "../../../components/molecules/TablaMonitoreoVistaProgramados/TablaMonitoreoVistaProgramados";
import TablaMonitoreoVistaProgramados2 from "../../../components/molecules/TablaMonitoreoVistaProgramados/TablaMonitoreoVistaProgramados2";
import TitleView from "../../../components/atoms/TitleView/TitleView";
import { getClients } from "../MonitoreoServicios/MonitoreoServiciosIntegracion";
import { transferisServiciosIntegracion } from "../TransferirServicios/transferisServiciosIntegracion";
import { formateoBasico } from "../../../utilities/formateos";
import { VistaProgramadosIntegracion } from "./VistaProgramadosIntegracion";
import GlovalCard from "../../../components/atoms/GlovalCard/GlovalCard";
import ScrollToTopButton from "../../../components/atoms/ScrollToTopButton";

const VistaProgramados = () => {


    // inputs
    const [vistaProgramados, setVistaProgramados] = useState([])

    const [totales, setTotales] = useState([])
    const [clientes, setClientes] = useState([])
    const [cliente, setCliente] = useState(null)
    const [rutas, setRutas] = useState([])
    const [ruta, setRuta] = useState(null)
    const [proveedores, setProveedores] = useState([])
    const [proveedor, setProveedor] = useState(null)
    const [fechaActual, setfechaActual] = useState(new Date())
    const [fechaInicial, setFechaInicial] = useState(formateoBasico(new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1)))
    const [fechaFinal, setFechaFinal] = useState(formateoBasico(new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0)))

    useEffect(() => {
        getClients(setClientes)
        transferisServiciosIntegracion.getProveedores(setProveedores)
    }, [])
    useEffect(() => {
        if (cliente) {
            transferisServiciosIntegracion.getRutesByIdClient(cliente.code, setRutas)
        }
    }, [cliente])
    useEffect(() => {
        if (proveedor) {
            setCliente(null)
            setRuta(null)
        }

    }, [proveedor])
    useEffect(() => {
        if (cliente || ruta) {
            setProveedor(null)
        }

    }, [cliente, ruta])



    const getVistaProgramados = () => {
        const data = {
            fecha_inicio: `'${fechaInicial} 00:00:00'`,
            fecha_fin: `'${fechaFinal} 23:59:59'`,
            proveedor: proveedor?.code ? proveedor.code : null,
            cliente: cliente?.code ? cliente.code : null,
            ruta: ruta?.code ? ruta.code : null
        }

        VistaProgramadosIntegracion.getVistaProgramados(data, setVistaProgramados, setTotales)
    }



    return (
        <div className="VistaProgramados">
            <ScrollToTopButton></ScrollToTopButton>
            <TitleView title={"Vista programados"}></TitleView>
            <b>
                <GlovalCard>
                    <div className="containerFiltros">
                        <InputLista options={clientes} value={cliente} onChange={(e) => { setCliente(e.value) }} className="tamañoInput" titulo={"Cliente"}></InputLista>
                        <InputLista options={rutas} value={ruta} onChange={(e) => { setRuta(e.value) }} className="tamañoInput" titulo={"Ruta"}></InputLista>
                        <InputLista options={proveedores} value={proveedor} onChange={(e) => { setProveedor(e.value) }} className="tamañoInput" titulo={"Proveedor"}></InputLista>
                        <InputCalendario onChange={(e) => { setFechaInicial(e.target.value) }} value={fechaInicial} className="tamañoInput" titulo={"Fecha inicial"}></InputCalendario>
                        <InputCalendario onChange={(e) => { setFechaFinal(e.target.value) }} value={fechaFinal} className="tamañoInput" titulo={"Fecha final"}></InputCalendario>
                        <Button className={"buttonMargin tamañoInput"} onClick={() => { getVistaProgramados() }}>Buscar</Button>
                    </div>
                    {


                        vistaProgramados.map((item, key) => {

                            return (
                                <>
                                    <div className="table1">
                                        <TablaMonitoreoVistaProgramados data={item} desde={fechaInicial} hasta={fechaFinal}></TablaMonitoreoVistaProgramados>
                                        {
                                            totales[key].total_sencillos != 0 ?
                                                <>
                                                    <div className="datosGenerales">
                                                        <div className="textoTabla">
                                                            <div>Ruta</div>
                                                            <div>{item[0].RUTA}</div>
                                                        </div>
                                                        <div className="textoTabla">
                                                            <div>Periodo</div>
                                                            <div>{fechaInicial + " a " + fechaFinal}</div>
                                                        </div>
                                                        <div className="textoTabla">
                                                            <div>Total Sencillos </div>
                                                            <div className="total_data_down" style={{ background: "var(--orange1)" }}>{totales[key].total_sencillos + " Sencillos"}</div>
                                                        </div>
                                                        <div className="textoTabla">
                                                            <div>Facturar</div>
                                                            <div>{item[0].APLICAR_FACTURA > 0 ? "si" : "no"}</div>
                                                        </div>
                                                        <div className="textoTabla">
                                                            <div>Total</div>
                                                            <div>{"$ " + totales[key].dinero_total_sencillos + ".00"}</div>
                                                        </div>
                                                    </div>
                                                </> :
                                                ""
                                        }
                                        {
                                            totales[key].total_medios != 0 ?
                                                <>
                                                    <div className="datosGenerales">
                                                        <div className="textoTabla">
                                                            <div>Ruta</div>
                                                            <div>{item[0].RUTA}</div>
                                                        </div>
                                                        <div className="textoTabla">
                                                            <div>Periodo</div>
                                                            <div>{fechaInicial + " a " + fechaFinal}</div>
                                                        </div>
                                                        <div className="textoTabla">
                                                            <div>Total Medios</div>
                                                            <div className="total_data_down">{totales[key].total_medios + " Medios"}</div>
                                                        </div>
                                                        <div className="textoTabla">
                                                            <div>Facturar</div>
                                                            <div>{item[0].APLICAR_FACTURA > 0 ? "si" : "no"}</div>
                                                        </div>
                                                        <div className="textoTabla">
                                                            <div>Total</div>
                                                            <div>{"$ " + totales[key].dinero_total_medios + ".00"}</div>
                                                        </div>
                                                    </div>
                                                </> :
                                                ""
                                        }
                                        <div className="datosGenerales">
                                            <div className="textoTabla">
                                                <div>Total facturar</div>
                                                <div className="total_data_down">{totales[key].total_ruta + " $"}</div>
                                            </div>
                                            <div className="textoTabla">
                                                <div>Total facturar</div>
                                                <div className="total_data_down">{totales[key].total_ruta + " $"}</div>
                                            </div>
                                            <div className="textoTabla">
                                                <div>Total facturar</div>
                                                <div className="total_data_down">{"$ " + totales[key].total_ruta + ".00"}</div>
                                            </div>
                                        </div>
                                    </div>

                                </>
                            )




                        })
                    }
                </GlovalCard>
            </b >
        </div>
    )
}
export default VistaProgramados